import React from "react";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "../pages/home/home";
import Debito from "../pages/debito/debito";
import Auth from "../auth/auth";
import ReclamosReconexiones from "../pages/reclamosReconexiones/reclamosReconexiones";
import CorreosElectronicos from "../pages/correosElectronicos/correosElectronicos";
import DeclaracionArtefactos from "../pages/declaracionArtefactos/declaracionArtefactos";
import Bienestar from "../pages/bienestar/bienestar";

const Rutas = () => {
  return (
    <Routes>
      <Route exact path="/" element={<Home />} />
      <Route
        exact
        // path="tramites/servicios"
        path="/servicios"
        element={
          <Auth>
            <ReclamosReconexiones />
          </Auth>
        }
      />
      <Route
        exact
        // path="tramites/debito"
        path="/debito"
        element={
          <Auth>
            <Debito />
          </Auth>
        }
      />
      <Route
        exact
        // path="tramites/actualizar-email"
        path="/actualizar-email"
        element={
          <Auth>
            <CorreosElectronicos />
          </Auth>
        }
      />
      <Route
        exact
        // path="tramites/electrodomesticos"
        path="/electrodomesticos"
        element={
          <Auth>
            <DeclaracionArtefactos />
          </Auth>
        }
      />

      <Route
        exact
        // path="tramites/bienestar-cooperativo"
        path="/bienestar-cooperativo"
        element={
          <Auth>
            <Bienestar />
          </Auth>
        }
      />

      {/* Cualquier ruta inexistente (ej: /login) cae al inicio en lugar de
          dejar la pantalla en blanco. */}
      <Route path="*" element={<Home />} />
    </Routes>
  );
};

export default Rutas;
